import { makeStyles, fade } from '@material-ui/core/styles';

export const AddInvoiceSideBarCss = makeStyles((theme) => ({

    partySelectDrawer: {
        width: 538,
        maxWidth: 538,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    invoiceDetailsDrawer: {
        width: 850,
        maxWidth: 850,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 20,
        marginBottom: 4,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 24,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    listingDiv: {
        marginTop: 24
    },
    subTitleSec: {
        marginBottom: 8,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    subTitleTxt: {
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(11, 19, 35, 0.5)"
    },
    partyDiv: {
        padding: 16,
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        marginBottom: 12,
        borderRadius: 8,
        cursor: "pointer",
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'cente',
        justifyContent: 'space-between'
    },
    nameDiv: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16
    },
    highlight: {
        color: "#1860f0",
        padding: 0,
        backgroundColor: 'transparent'
    },
    balanceDiv: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16
    },
    partyBalance: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323',
    },
    search: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#fff",
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        border: "solid 1px rgba(11, 19, 35, 0.5)",
        marginRight: 0,
        marginLeft: 0,
        width: '100%',
    },
    searchIcon: {
        padding: "0px 12px",
        height: '100%',
        color: "rgba(11, 19, 35, 0.75)",
        //position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    sicon: {
        fontSize: 18
    },
    closeIcon: {
        padding: "0px 12px",
        height: '100%',
        color: "rgba(11, 19, 35, 0.75)",
        //position: 'absolute',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        fontSize: 14,
        padding: "12px 0px",
        //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        width: '100%'
    },
    backButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    createInvoiceButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    createInvoiceButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada !important',
        color: '#5e636c !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#dadada !important'
        }
    },
    gridContainer: {
        padding: '16px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    mtV1: {
        marginTop: 8
    },
    titleV1: {
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.5)',
        textAlign: 'left'
    },
    titleV2: {
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.5)',
        textAlign: 'right'
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    titleV3: {
        fontSize: '14px',
        fontWeight: '600',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV2: {
        marginTop: 24
    },
    mtV3: {
        marginTop: 4
    },
    eventIcon: {
        color: 'grey',
    },
    fwNormal: {
        fontWeight: 'normal'
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600
    },
    thTruckRightAlignV1: {
        backgroundColor: '#E3E8FD',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 36,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    invoiceAmount: {
        textAlign: 'right',
        fontWeight: 600,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    infoIcon: {
        fontSize: 16,
        color: '#8199E5'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'normal'
    },
    mlV1: {
        marginLeft: 4
    },
    divAlignV2: {
        display: 'flex',
        alignItems: 'center'
    },
    mtV4: {
        marginTop: '-4px',
        marginLeft: '4px'
    },
    divTable: {
        marginTop: '24px'
    },
    titleV4: {
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    divAlignV4: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    compareIcon: {
        fontSize: 12,
        marginLeft: 12
    },
    divSort: {
        color: '#0033cc',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600
    },
    sortButton: {
        textTransform: 'none',
        fontSize: 14,
        fontWeight: 600,
        color: '#0033cc',
        paddingTop: 3,
        paddingBottom: 3
    },
    textFieldV1: {
        // width: '198px',
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    textFieldV2: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#efefef',
            color: '#7b7b7b',
            height: 36
        }
    },
    divContainer: {
        display: 'flex',
    },
    divContainerItem: {
        marginRight: 16
    },
    divTripError: {
        color: '#ff0000',
        marginTop: 24,
        fontSize: 16
    },
    menuItem: {
        borderBottom: '1px solid #ebebeb',
        backgroundColor: 'white'
    },
    selectRoot: {
        backgroundColor: 'transparent !important'
    },
    sortIcon: {
        marginLeft: 4,
        fontSize: 16
    }

}));